import {NgModule} from '@angular/core';
import {CurrencyNumberPipe} from './currency';
import {LocalizedDatePipe} from './localizedDate';
import {TestPipe} from './test.pipe';
import {MaskedPhonePipe} from 'app/pipes/maskedPhone';

@NgModule({
  imports: [],
  declarations: [CurrencyNumberPipe, LocalizedDatePipe, TestPipe, MaskedPhonePipe],
  exports: [CurrencyNumberPipe, LocalizedDatePipe, TestPipe, MaskedPhonePipe]
})
export class PipesModule {
}



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/pipes/pipes.module.ts